// Light/dark theme. Follows the system setting by default; the user can pick light or dark in the navbar.
// public/index.html applies the saved choice before React loads, so the page never flashes the wrong theme.

import { useEffect, useState } from 'react';

const KEY = 'theme';
export const THEMES = ['system', 'light', 'dark'];

const media = () => window.matchMedia('(prefers-color-scheme: dark)');

export const getPreference = () => {
  try {
    return localStorage.getItem(KEY) || 'system';
  } catch {
    return 'system';
  }
};

export function applyTheme(preference) {
  const theme = preference === 'system' ? (media().matches ? 'dark' : 'light') : preference;
  const root = document.documentElement;
  root.classList.add('theme-switching'); // no colour transitions while switching
  root.setAttribute('data-theme', theme);
  root.setAttribute('data-bs-theme', theme); // Bootstrap's own dark mode
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#14130f' : '#f1ece1');
  requestAnimationFrame(() => requestAnimationFrame(() => root.classList.remove('theme-switching')));
}

export function useTheme() {
  const [preference, setPreference] = useState(getPreference);

  useEffect(() => {
    applyTheme(preference);
    try {
      if (preference === 'system') localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, preference);
    } catch {
      // Private mode etc.: the choice just isn't remembered
    }
    if (preference !== 'system') return undefined;
    const onChange = () => applyTheme('system');
    media().addEventListener('change', onChange);
    return () => media().removeEventListener('change', onChange);
  }, [preference]);

  const cycle = () => setPreference(p => THEMES[(THEMES.indexOf(p) + 1) % THEMES.length]);
  return { preference, cycle };
}
